import type { SVGProps } from 'react';

export function DiceIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.703 2.486a2.695 2.695 0 0 0-3.304 1.91L2.494 11.5a2.7 2.7 0 0 0 1.908 3.308l7.107 1.905a2.7 2.7 0 0 0 3.307-1.909L16.721 7.7a2.7 2.7 0 0 0-1.908-3.308zm.862 7.714a1.2 1.2 0 0 1-.022-1.219 1.2 1.2 0 0 1 2.1.02 1.2 1.2 0 1 1-2.078 1.2m-3.195.461a1.2 1.2 0 1 1 1.2 2.077c-.371.23-.84.237-1.219.023a1.2 1.2 0 0 1 .019-2.1m6.937 3.615c-.37.23-.84.237-1.218.023a1.2 1.2 0 0 1 .018-2.1c.372-.229.84-.236 1.22-.023a1.2 1.2 0 0 1-.02 2.1m.338-7.815a1.2 1.2 0 1 1 1.2 2.078 1.2 1.2 0 1 1-1.2-2.078m-4.537.54a1.2 1.2 0 1 1-1.2-2.077c.37-.229.84-.236 1.218-.023a1.2 1.2 0 0 1-.018 2.1m9.967 2.6-1.523 5.67a4.505 4.505 0 0 1-5.512 3.183l-1.436-.386V19.2c0 1.324 1.076 2.4 2.4 2.4h7.2c1.323 0 2.4-1.076 2.4-2.4V12c0-1.324-1.076-2.4-2.4-2.4z" />
    </svg>
  );
}
